import React, { ComponentProps, useRef } from 'react';
import { Text, Icon, Pill, Flex, Tooltip, Box } from '@fullstory/components';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { FormattedMessage } from 'react-intl';

export const VisibilityLabel: React.FC<{
  visibility?: Visibility | null;
  tooltipContent: ComponentProps<typeof Tooltip>['tooltipContent'];
  showLock?: boolean;
  showPill?: boolean;
}> = ({ visibility, tooltipContent, showLock, showPill = true }) => {
  const tooltipAnchor = useRef<HTMLDivElement>(null);
  return (
    <>
      {!!visibility && visibility === Visibility.PRIVATE && (
        <Tooltip
          testId="visibility-label"
          anchor={tooltipAnchor.current}
          tooltipContent={tooltipContent}
        >
          <Flex alignItems="center" gap={4}>
            <Box ref={tooltipAnchor}>
              {showPill && (
                <Pill variant="compact-outline" color="secondary" noExternalSpacing>
                  <Text appearance="bodyXSmallBold">
                    <FormattedMessage defaultMessage="Private" id="viXE32" />
                  </Text>
                </Pill>
              )}
            </Box>
            {showLock && <Icon name="lock" color="secondary" />}
          </Flex>
        </Tooltip>
      )}
    </>
  );
};
